import { isDev } from '@/constants/env'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import type { HTMLAttributes } from 'react'
import RouterDevTool from './RouterDevTool'

export interface DevToolsProps extends HTMLAttributes<HTMLDivElement> {}

export default function DevTools({ ...props }: DevToolsProps) {
	if (!isDev) return null

	return (
		<>
			<RouterDevTool />
			<ReactQueryDevtools />
		</>
	)
}
